export default __webpack_public_path__ + "static/media/corevalue-happiness.83c77ec2.png";